import _ttmlFunc from "../functions/profiles/ttmlGeneral.js";
import _eol from "eol";
import _convertToPlainTextCustom from "../functions/quill/convertToPlainTextCustom.js";
import _getFormatOptions from "../functions/helpers/getFormatOptions.js";
import _removeInvalidEvents from "../functions/eventGroups/removeInvalidEvents.js";
import _tcLib from "../lib/timecode.js";
const tcLib = _tcLib;
const removeInvalidEvents = _removeInvalidEvents;
const getFormatOptions = _getFormatOptions;
const convertToPlainTextCustom = _convertToPlainTextCustom;
const eol = _eol;
const ttmlFunc = _ttmlFunc;
export default {
  decode: function (input, options) {
    throw new Error("Decoding TTML Disney profile is not supported. Please use the TTML General profile for decoding or contact support.");
  },
  encode: function (eventGroup, options) {
    let encodingOptions = getFormatOptions(options.formatOptions);
    let frameRateMultiplier = ttmlFunc.frameRateMultiplierMap[options.frameRate];
    let output = `<?xml version="1.0" encoding="utf-8"?>`;
    output += `<tt xmlns:tts="http://www.w3.org/ns/ttml#styling" xmlns:ttm="http://www.w3.org/ns/ttml#metadata" xmlns:ttp="http://www.w3.org/ns/ttml#parameter" xml:lang="${encodingOptions["Language Code"] ?? 'en'}" ttp:frameRateMultiplier="${frameRateMultiplier}" ttp:contentProfiles="http://www.w3.org/ns/ttml/profile/imsc1.1/text" ttp:timeBase="media" ttp:frameRate="${ttmlFunc.frameRateMap[options.frameRate] ?? Math.round(options.frameRate)}" xmlns="http://www.w3.org/ns/ttml">`;
    /* Head Section */
    output += `
\t<head>
    \t<styling>
    \t\t<style xml:id="style.center" tts:backgroundColor="transparent" tts:color="white" tts:fontFamily="proportionalSansSerif" tts:fontSize="80%" tts:fontStyle="normal" tts:fontWeight="normal" tts:textAlign="center" tts:textOutline="black 4%" />
    \t</styling>
    \t<layout>
    \t\t<region xml:id="region.after" tts:displayAlign="after" tts:origin="5% 5%" tts:extent="90% 90%" tts:luminanceGain="3.0" />
    \t\t<region xml:id="region.before" tts:displayAlign="before" tts:origin="5% 5%" tts:extent="90% 90%" tts:luminanceGain="3.0" />
    \t</layout>
\t</head>
\t<body>
\t\t<div>
`;

    /* EVENTS */
    eventGroup.events.forEach((event, index, events) => {
      //create start and end time in format hh:mm:ss.mm
      let start = tcLib.secToFrames(event.start, options.frameRate, options.dropFrame);
      let end = tcLib.secToFrames(event.end, options.frameRate, options.dropFrame);
      let region = event.yPos === "start" ? "region.before" : "region.after";

      //console.log(event.text);
      let plainTextCustom = convertToPlainTextCustom(event.text);
      let text = ttmlFunc.multiLine.convertToTtml(plainTextCustom);
      // console.log(text);
      output += eol.after(`\t\t\t<p begin="${start}f" end="${end}f" region="${region}" style="style.center">${text}</p>`);
    });
    output += eol.after(`\t\t</div>`);
    output += eol.after(`\t</body>`);
    output += `</tt>`;
    return eol.auto(output);
  },
  preProcess: {
    encode: function (eventGroup) {
      return removeInvalidEvents(eventGroup);
    },
    decode: function (input) {
      return eol.lf(input);
    }
  },
  postProcess: {
    encode: function (output) {
      return output;
    },
    decode: function (eventGroup) {
      return eventGroup;
    }
  }
};